import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dolphin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      const hadToken = !!localStorage.getItem("dolphin_token");
      localStorage.removeItem("dolphin_token");
      if (window.location.pathname !== "/login") {
        if (hadToken) sessionStorage.setItem("dolphin_session_expired", "1");
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  // FastAPI/Pydantic 422 returns detail as an array of {loc,msg,type,...}.
  // Render a friendly string instead of letting React try to render an object (which crashes the UI).
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      if (typeof d === "string") return d;
      const field = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
      return field ? `${field}: ${d?.msg || "invalid"}` : (d?.msg || "Invalid input");
    });
    return parts.join("; ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || JSON.stringify(detail);
  }
  return (
    detail ||
    e?.response?.data?.error ||
    e?.message ||
    "Something went wrong."
  );
}
